<template>
  <div class="details">
    <div class="content_title" frag="窗口12" portletmode="simpleArticleAttri">
      <h2>{{ data.articleTitle }}</h2>
      <div class="cont_tit">
        作者 ：<span>{{ data.articleAuthor }} </span> 编辑 ：<span
          >{{ data.articleEdit }} </span
        >&nbsp;&nbsp;&nbsp;&nbsp;发布时间 ：<span>{{ data.createTime }}</span
        >&nbsp;&nbsp;&nbsp;&nbsp;来源 ：<span>{{ data.articleSource }}</span>
      </div>
    </div>
    <div class="content_main">
      <div class="ql-editor" v-html="data.articleContent"></div>
    </div>
  </div>
</template>

<script>
import { articleDetail } from "@/api/article";
export default {
  data() {
    return {
      articleId: "",
      data: {},
    };
  },
  computed: {},
  watch: {
    "$route.query": {
      immediate: true,
      handler(val) {
        if (val.artilceId) {
          this.getData(val.artilceId);
        }
      },
    },
  },
  methods: {
    async getData(id) {
      const { code, data } = await articleDetail({
        id,
      });
      if (code == 200) {
        this.data = data;
      }
    },
    backHome() {},
  },
};
</script>

<style lang="scss" scoped>
.details {
  margin: 0 auto;
  padding: 0;
  width: 875px;

  .content_title {
    font-family: "microsoft yahei";
    font-size: 16px;
    color: #333;
    padding: 0px;
    margin: 0;
    text-align: center;
    width: 100%;
    border-bottom: 1px dashed #c0c0c0;
    padding-bottom: 30px;
    margin-bottom: 30px;
    h2 {
      font-family: "microsoft yahei";
      text-align: center;
      margin: 0px;
      font-size: 22px;
      font-weight: bold;
      color: #333;
      padding: 0 40px;
      line-height: 44px;
    }
    .cont_tit {
      text-align: center;
      margin: 0px;
      padding: 0px;
      margin-top: 15px;
      position: relative;
      font-size: 16px;
      color: #aaa;
      span{
        font-size: inherit;
      }
    }
  }
  .content_main {
    font-family: "microsoft yahei";
    font-size: 16px;
    margin: 0px;
    padding: 0px;
    width: 875px;
    color: #333333;
    overflow: hidden;

    ::v-deep .ql-editor {
      font-size: 18px;
      word-wrap: break-word;
      word-break: break-all;
      overflow-wrap: break-word;

      * {
        font-size: inherit !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
      }

      a {
        display: inline !important;
        white-space: normal !important;
        word-break: break-all !important;
        overflow-wrap: break-word !important;
        max-width: 100% !important;
        color: #333;
      }
    }
  }

}

</style>
